import { AiPromptUseCase, type AiPromptUseCaseId } from '../../admin/types/AiPromptConfig';

export type AssignableUseCaseOption = {
  id: AiPromptUseCaseId;
  labelKey: string;
  descriptionKey: string;
};

/** Pre-selected when creating or importing tools so publish enables reply by default. */
export const DEFAULT_ASSIGNED_USE_CASE_IDS: AiPromptUseCaseId[] = [AiPromptUseCase.ReplyDefault];

export const ASSIGNABLE_USE_CASES: AssignableUseCaseOption[] = [
  {
    id: AiPromptUseCase.ReplyDefault,
    labelKey: 'useCaseReply',
    descriptionKey: 'useCaseReplyHint',
  },
  {
    id: AiPromptUseCase.ReplyMention,
    labelKey: 'useCaseReplyMention',
    descriptionKey: 'useCaseReplyMentionHint',
  },
  {
    id: AiPromptUseCase.ReplyExternalUnmuted,
    labelKey: 'useCaseReplyExternal',
    descriptionKey: 'useCaseReplyExternalHint',
  },
  {
    id: AiPromptUseCase.ReplyInstagramComment,
    labelKey: 'useCaseReplyInstagramComment',
    descriptionKey: 'useCaseReplyInstagramCommentHint',
  },
  {
    id: AiPromptUseCase.ReplyMessengerComment,
    labelKey: 'useCaseReplyMessengerComment',
    descriptionKey: 'useCaseReplyMessengerCommentHint',
  },
  {
    id: AiPromptUseCase.ReplyWhatsAppGroup,
    labelKey: 'useCaseReplyWhatsAppGroup',
    descriptionKey: 'useCaseReplyWhatsAppGroupHint',
  },
  {
    id: AiPromptUseCase.Draft,
    labelKey: 'useCaseDraft',
    descriptionKey: 'useCaseDraftHint',
  },
  {
    id: AiPromptUseCase.Summary,
    labelKey: 'useCaseSummary',
    descriptionKey: 'useCaseSummaryHint',
  },
  {
    id: AiPromptUseCase.FollowUp,
    labelKey: 'useCaseFollowUp',
    descriptionKey: 'useCaseFollowUpHint',
  },
  {
    id: AiPromptUseCase.TaskAgent,
    labelKey: 'useCaseTaskAgent',
    descriptionKey: 'useCaseTaskAgentHint',
  },
];
